<div class="custom-mapping pb-2">
  <div class="d-flex">
    <div class="mt-3 mb-2 flex-grow-1 align-items-center">
      <span class="secondary-details mr-2">{{
        'mapping.customMapping.createEditShipmentSpecification' | translate
      }}</span>
      <small class="text-danger text-right">
        11 {{ 'mapping.customMapping.allIndicatedFieldsMandatory' | translate }}</small
      >
    </div>
    <div>
      <button
        *ngIf="specMode == 'List'"
        class="me-1 icon-mat"
        (click)="specMode = 'Create'"
        #tooltip="matTooltip"
        matTooltip="Create"
        mat-raised-button>
        <em class="bi bi-plus"></em>
      </button>
      <button class="secondary-btn" (click)="specMode = 'List'" *ngIf="specMode !== 'List'">
        {{ 'global.back' | translate }}
      </button>
      <button class="icon-mat" matTooltip="Delete" mat-raised-button>
        <i class="bi bi-trash"></i>
      </button>
    </div>
  </div>

  <div class="row mt-2">
    <div class="col-md-6 mt-2">
      <ng-container *ngIf="specMode === 'Create' || specMode === 'Edit'">
        <!-- <div class="w-50 mt-2" *ngIf="specMode === 'Edit'">
          <label>Select Specification</label>
          <mat-select
            class="form-control"
            [(ngModel)]="selectedSpec"
            (selectionChange)="specSelectEvent($event)"
            placeholder="Select specification">
            <mat-option *ngFor="let spec of mappingOptions" [value]="spec">
              {{ spec.specifications_id }}-{{ spec.file_format }}
            </mat-option>
          </mat-select>
        </div> -->
        <div class="row" [formGroup]="shipmentMappingForm">
          <div>
            <div class="row mt-2">
              <div class="col-md-2">
                <label class="required-field"
                  >{{ 'mapping.customMapping.specificationName' | translate }}
                </label>
              </div>
              <div class="col-md-5">
                <input
                  class="form-control"
                  maxlength="52"
                  size="52"
                  formControlName="specifications_id" />
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-2">
                <label class="control-label required-field">{{
                  'mapping.customMapping.formatType' | translate
                }}</label>
              </div>
              <div class="col-md-3">
                <mat-radio-group aria-label="Select an option" formControlName="file_format">
                  <mat-radio-button class="mr-2" value="EASYSHIP" (click)="easyship()"
                    >Easyship</mat-radio-button
                  >
                  <mat-radio-button value="STANDARD" (click)="standard()"
                    >Standard</mat-radio-button
                  >
                </mat-radio-group>
              </div>
              <div class="col-md-2">
                <label class="required-field">{{
                  'mapping.customMapping.delimiter' | translate
                }}</label>
              </div>
              <div class="col-md-1">
                <input class="input" maxlength="1" size="1" formControlName="delimiter" />
              </div>
            </div>
            <div class="row mt-2"></div>
            <div class="row">
              <div class="col-md-2">
                <label class="control-label">{{
                  'mapping.customMapping.abortDuringErrors' | translate
                }}</label>
              </div>
              <div class="col-md-5">
                <mat-checkbox formControlName="abortOnErrors"></mat-checkbox>
              </div>
            </div>

            <div class="row">
              <div class="col-md-2">
                <label class="control-label">{{
                  'mapping.customMapping.headers' | translate
                }}</label>
              </div>
              <div class="col-md-5">
                <mat-checkbox formControlName="headers"></mat-checkbox>
              </div>
            </div>

            <div class="row">
              <div class="col-md-2">
                <label class="control-label">{{
                  'mapping.customMapping.automatedUpload' | translate
                }}</label>
              </div>
              <div class="col-md-5">
                <mat-checkbox formControlName="use_for_automated_upload">{{
                  'mapping.customMapping.useForAutomatedUpload' | translate
                }}</mat-checkbox>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2">
                <label class="control-label required-field">{{
                  'mapping.customMapping.shipperAddress' | translate
                }}</label>
              </div>
              <div class="col-md-3 w-40">
                <mat-checkbox
                  (change)="isCheckedUseFromFile($event)"
                  formControlName="useFromFile"
                  >{{ 'mapping.customMapping.useFromFile' | translate }}</mat-checkbox
                >
                <br />
                <div *ngIf="!isUseFromFile">
                  <label>{{ 'mapping.customMapping.useShipperAddress' | translate }}</label>
                  <mat-select
                    class="form-control"
                    placeholder="Select Shipper"
                    (selectionChange)="changeAddressValue($event)"
                    formControlName="use_shipper_id">
                    <mat-option [value]=""> Select Shipper </mat-option>
                    <mat-option *ngFor="let address of shipperAddressData" [value]="address">
                      {{ address }}
                    </mat-option>
                  </mat-select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="col-md-6" *ngIf="specMode === 'Create' || specMode === 'Edit'">
      <div class="row mt-2 mb-2" cdkDropListGroup>
        <div class="col-md-5">
          <h5 class="ml-2">{{ 'mapping.customMapping.availableColumns' | translate }}</h5>
          <div class="example-container">
            <div
              style="height: 100vh; overflow-y: auto"
              cdkDropList
              id="cdk1"
              [cdkDropListData]="unMappedFields"
              class="example-list"
              (cdkDropListDropped)="drop($event)">
              <div class="example-box" *ngFor="let item of unMappedFields" cdkDrag>
                {{ item }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-5">
          <h5 class="ml-2">{{ 'mapping.customMapping.csvFileColumns' | translate }}</h5>
          <div class="example-container">
            <div
              style="height: 100vh; overflow-y: auto"
              cdkDropList
              id="cdk2"
              [cdkDropListData]="mappedFields"
              class="example-list"
              (cdkDropListDropped)="drop($event)">
              <div
                class="example-box"
                *ngFor="let item of mappedFields"
                [ngClass]="{ 'required-field': isFieldMondatory(item) }"
                cdkDrag>
                {{ item }}
                <div
                  *ngIf="item === 'lineItems'"
                  class="pointer"
                  [matTooltip]="lineItemLists"
                  #tooltip="matTooltip"
                  mat-raised-button>
                  <i class="bi bi-info-circle"></i>
                </div>

                <div
                  *ngIf="item === 'pieces'"
                  class="pointer"
                  [matTooltip]="pieceslists"
                  #tooltip="matTooltip"
                  mat-raised-button>
                  <i class="bi bi-info-circle"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="mt-2 mb-2" *ngIf="specMode === 'Create' || specMode === 'Edit'">
    <button type="submit" (click)="saveShipmentConfigMapping()" class="primary-btn pull-right">
      {{ 'global.save' | translate }}
    </button>
  </div>
</div>
